import React, { useState, useEffect, useRef } from 'react';
import { useHistory, useParams } from "react-router-dom";

import { classNames } from 'primereact/utils';
import { Button } from 'primereact/button';
import { InputText } from "primereact/inputtext";
import { showToast } from "../ToastManager";
import { FileUpload } from 'primereact/fileupload';
import { Image } from "primereact/image";

import Utils from "../../utilities/Utils";

import ImageService from "../../service/ImageService";
import EmpresaCategoriaService from '../../service/EmpresaCategoriaService';

const empresaCategoriaService = new EmpresaCategoriaService(); // Create an instance of EmpresaService
const imageService = new ImageService();

const CadastrarCategoriaEmpresa = () => {
    const iss = localStorage.getItem('iss');
    const history = useHistory();

    let categoriaNovo = {
        nome: '',
        descricao: '',
        file: '',
        excluido: 0
    };
    const [categoria, setCategoria] = useState(categoriaNovo);
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loading1, setLoading1] = useState(false);
    const [status, setStatus] = useState('');
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [avatar, setAvatar] = useState()
    const [formData, setFormData] = useState(new FormData())
    const fileUploadRef = useRef(null);
    const [dataLoaded, setDataLoaded] = useState(false);

    const { id } = useParams();

    useEffect(() => {
        const loadData = async () => {
            if (id && !dataLoaded) {
                try {
                    setLoading(true);
                    const data = await empresaCategoriaService.getEmpresaCategoria(iss, id)
                    const categoriaNovo = data.data.rows[0];

                    setAvatar(categoriaNovo.url)
                    formData.append('url', categoriaNovo.url)
                    setTimeout(() => {
                        setCategoria(categoriaNovo);
                    }, 200);
                    setDataLoaded(true);
                } catch (error) {
                    console.error("Erro ao carregar dados:", error);
                } finally {
                    setLoading(false);
                }
            }
        }
        loadData();
    }, [dataLoaded, formData, id, iss]);

    const onUpload = (e) => {
        setLoading1(true);

        formData.delete('url');
        formData.append('file', e.files[0]);
        setFormData(formData)

        fileUploadRef.current.clear();

        setAvatar(e.files[0].objectURL);
        setLoading1(false);
    }


    const onInputChange = (e, name, list = false, checkbox = false,) => {
        let val = (e.target && e.target.value) || '';
        let _categoria = { ...categoria };

        if (checkbox) {
            val = e.checked;
        }

        // Verifica se o nome tem um ponto
        if (name.includes('.')) {
            const [parent, child] = name.split('.'); // Divide o nome em pai e filho
            if (!_categoria[parent]) {
                _categoria[parent] = {}; // Cria o objeto pai se não existir
            }
            _categoria[parent][child] = val; // Define o valor do atributo filho
        } else {
            if (list) {
                _categoria[name] = val;
            } else {
                _categoria[name] = val; // Define o valor diretamente se não houver aninhamento
            }

        }
        setCategoria(_categoria);
    }

    const cadastrar = async () => {
        setSubmitted(true);
        if (categoria.nome && categoria.descricao) {
            setLoading(true)
            formData.append('nome', categoria.nome);
            formData.append('descricao', categoria.descricao);
            if (categoria.id != null) {
                empresaCategoriaService.putEmpresaCategoria(iss, formData, categoria.id).then(data => {
                    showToast({ severity: 'success', summary: 'Cadastro de agenda', detail: 'AgendaPrestador editada com sucesso' });
                    history.push('/empresa/categoria/listar');
                    return;

                }, error => {
                    showToast({ severity: 'error', summary: 'Erro ao editar', detail: 'Erro ao editar agenda' });
                }).finally(() => { setLoading(false) });
            } else {
                empresaCategoriaService.postEmpresaCategoria(iss, formData).then(data => {
                    showToast({ severity: 'success', summary: 'Cadastro de categoria empresa', detail: 'Categoria empresa cadastrada com sucesso' });
                    history.push('/empresa/categoria/listar');
                    return;

                }, error => {
                    showToast({ severity: 'error', summary: 'Erro ao cadastrar', detail: error.response.data.error.message });
                }).finally(() => { setLoading(false) });
            }
        } else {
            showToast({ severity: 'error', summary: 'Erro ao cadastrar', detail: 'Preencha todos os campos' });
        }
    }

    const handleKeyDown = (event, name) => {
        const { key } = event;
        const lastValue = categoria[name] || '';
        let _categoria = { ...categoria };
        if (key === 'Backspace') {
            const input = event.target;
            let cursorPos = input.selectionStart;
            if (cursorPos > 0 && (input.value[cursorPos - 1] === '.' || input.value[cursorPos - 1] === '-')) {
                event.preventDefault(); // Prevent default to manually handle backspace
                let newValue = lastValue.substring(0, cursorPos - 1) + lastValue.substring(cursorPos);
                newValue = newValue.replace(/\D/g, '');
                _categoria.cnpj = Utils.formatCnpj(newValue); // Apply mask after removal
                setCategoria(_categoria);
            }
        }
    };

    return (
        <div className="grid">
            <h4>Informações da Categoria de Empresa</h4>
            <div className="col-12">
                <div className="card">
                    <div className="grid">
                        <div style={{ marginTop: 10 }} className="field col-12 md:col-2">
                            <div style={{
                                width: 160,
                                height: 160,
                                border: 'solid',
                                borderWidth: '0.5px',
                                borderRadius: '8px',
                                borderColor: 'rgba(255,255,255,0.35)',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                cursor: 'pointer'
                            }} >
                                <Image src={avatar} alt="Image"
                                    width="150" height="auto" />
                            </div>
                        </div>
                        <div style={{ marginTop: 10 }} className="field col-12 md:col-4">
                            <h5>Adicionar/Alterar</h5>
                            <FileUpload loading={loading} ref={fileUploadRef} className="mr-2 mb-2"
                                chooseLabel={'Imagem'}
                                mode="basic"
                                name="avatar[]"
                                customUpload={true}
                                auto={true}
                                uploadHandler={onUpload} accept="image/*" maxFileSize={1000000} />
                            {/* <FileUpload name="image" url={avatar} onUpload={onUpload()} multiple accept="image/*" maxFileSize={1000000} /> */}
                        </div>
                    </div>
                    <div style={{ marginTop: 10 }} className="p-fluid formgrid grid">
                        <div style={{ marginTop: 10 }} className="field col-4">
                            <span className="p-float-label">
                                <InputText value={categoria.nome} onChange={(e) => onInputChange(e, 'nome')}
                                    className={classNames({ 'p-invalid': submitted && !categoria.nome })} required id="nome" type="text" />
                                <label htmlFor="nome">Nome</label>
                            </span>
                            {submitted && !categoria.nome && <small className="p-invalid">Nome é obrigatório.</small>}
                        </div>

                        <div style={{ marginTop: 10 }} className="field col-8">
                            <span className="p-float-label">
                                <InputText value={categoria.descricao} onChange={(e) => onInputChange(e, 'descricao')}
                                    className={classNames({ 'p-invalid': submitted && !categoria.descricao })} required id="descricao" type="text" />
                                <label htmlFor="descricao">Descrição</label>
                            </span>
                            {submitted && !categoria.descricao && <small className="p-invalid">Descrição é obrigatório.</small>}
                        </div>

                        <Button label={id != null ? 'Atualizar' : 'Cadastrar'} loading={loading} style={{ width: '100%', marginTop: 10 }}
                            onClick={cadastrar} className="mr-2 mb-2"></Button>

                        <div onClick={history.goBack} style={{ width: '100%', marginTop: 10, textAlign: 'center', cursor: 'pointer' }}>
                            <i className="pi pi-arrow-left"></i><span style={{ marginLeft: 10, }}>Voltar</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(CadastrarCategoriaEmpresa, comparisonFn);
